import axios from 'axios'
import { i18n } from '@/plugins/i18n'
import { localize } from 'vee-validate';

const Trans = {
	get defaultLanguage () {
		return process.env.VUE_APP_I18N_LOCALE
	},
	get supportedLanguages () {
		return process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(',')
	},
	get currentLanguage () {
		return i18n.locale
	},
	set currentLanguage (lang) {
		i18n.locale = lang
	},
	setI18nLanguageInServices (lang) {
		Trans.currentLanguage = lang
		axios.defaults.headers.common['Accept-Language'] = lang
		document.querySelector('html').setAttribute('lang', lang)
		Trans.loadLocale(lang)
		return lang
	},
	changeLanguage (lang) {
		if (i18n.locale === lang) return Promise.resolve(lang)
		return Trans.loadLanguageFile(lang).then(msgs => {
			i18n.setLocaleMessage(lang, msgs.default || msgs)
			return Trans.setI18nLanguageInServices(lang)
		})
	},
	loadLanguageFile (lang) {
		import(`vue2-datepicker/locale/${lang}.js`);
		import(`moment/locale/${lang === 'en' ? 'es-us' : lang}.js`);
		return import( /* webpackChunkName: "lang-[request]" */ `@/locales/${lang}/index.js`);
	},
	loadLocale(lang) {
		return import(`vee-validate/dist/locale/${lang}.json`).then(locale => {
			localize(lang, locale);
		});
	},
	routeMiddleware (to, from, next) {
		const lang = to.params.lang || Trans.defaultLanguage
		return Trans.changeLanguage(lang).then(() => next())
	},
	i18nRoute (to) {
		return { ...to, params: {
			lang: Trans.defaultLanguage === this.currentLanguage ? undefined : this.currentLanguage,
			...to.params
		}}
	}
}

export { Trans }
